import {
  useAuth,
} from 'core/hooks';
import ErrorBoundary from 'pages/Dashboard/components/ErrorBoundary';
import React, {
  PropsWithChildren,
} from 'react';
import {
  APP_ROUTES,
} from 'views/EMR/router';

export default function ErrorBoundaryWithAuth({ children }: PropsWithChildren) {
  const {
    logout,
    isAuthenticated,
    isGoogleOAuth2,
  } = useAuth();

  return (
    <ErrorBoundary
      {...(isAuthenticated
        ? {
          onLogout: () => {
            logout({
              returnTo: `${window.location.origin}${isGoogleOAuth2 ? APP_ROUTES.POPULATE_SUPPORT.ROOT : ''}`,
            });
          },
        } : {})}
    >
      {children}
    </ErrorBoundary>
  );
}
